/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
import axios from 'axios';
import moment from 'moment';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import FilteredUnit from '../../../constants/FilteredUnit';
import {financialYear} from '../../../interface/Units';
import {OPKey} from '../../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const companyDetails = async (data: any = undefined, shouldCall: boolean = false ): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyId = useCompanyStore.getState().companyId;
  const companyDetails = useCompanyStore.getState().companyDetails;

  if (Object.keys(companyDetails).length === 0 || shouldCall) {
    try {
      const res = await axios.request({
        method: data ? CRUDMethods.PUT : CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.companyDetails}/${companyId}`,
        data: data ?? {},
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {}
      });

      const mainData = res.data.data;

      if (mainData) {
        mainData[OPKey.BUSINESS_EMAIL] = mainData[OPKey.PERSONAL_EMAIL];
        delete mainData[OPKey.PERSONAL_EMAIL];
        delete mainData[OPKey.TOTAL_FLOOR_SPACE];
        delete mainData[OPKey.FLEET_NUM];
        delete mainData[OPKey.TOTAL_EMP];
        delete mainData[OPKey.TOTAL_REVENUE];
        useCompanyStore.setState({
          companyDetails: {
            ...mainData,
            incorporationYear: mainData?.incorporationYear
              ? moment(`01-01-${mainData.incorporationYear}`, 'MM/DD/YYYY')
              : undefined,
            baseLineYear: mainData?.baseLineYear
              ? moment(`01-01-${mainData.baseLineYear}`, 'MM/DD/YYYY')
              : undefined,
            targetYear: mainData?.targetYear
              ? moment(`01-01-${mainData.targetYear}`, 'MM/DD/YYYY')
              : undefined
          }
        });

        useCompanyStore.getState().setPreUnits({
          ...FilteredUnit(mainData?.[OPKey.COMPANY_COUNTRY]),
          financialYear:
            mainData?.[OPKey.FINANCIAL_YEAR_TYPE] ?? financialYear.AprMar
        });
      }

      return res.data;
    } catch (err) {
      useCompanyStore.setState({companyDetails: {}});

      return await Promise.reject(new Error('Something wrong'));
    }
  }
};

export default companyDetails;
